import { sanitizeReturnPath } from '@/routes/returnPath';

export const safeLeagueReturnTo = (value: unknown, fallback: string): string => sanitizeReturnPath(value, fallback);

const playerUUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const playerDetailPath = /^\/(players|scouting)\/([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})$/i;

export const safeExternalPlayerReturnTo = (value: unknown, playerId: string): string => {
  const fallback = `/scouting/${encodeURIComponent(playerId)}`;
  if (!playerUUID.test(playerId) || typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return fallback;
  try {
    const rawPathname = value.split(/[?#]/, 1)[0];
    const parsed = new URL(value, 'https://local.invalid');
    const match = playerDetailPath.exec(parsed.pathname);
    if (rawPathname !== parsed.pathname || parsed.origin !== 'https://local.invalid' || !match || match[2].toLowerCase() !== playerId.toLowerCase()) return fallback;
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return fallback;
  }
};

export const positiveRouteId = (value: string | undefined): number | null => {
  if (!value || !/^[1-9]\d*$/.test(value)) return null;
  const id = Number(value);
  return Number.isSafeInteger(id) ? id : null;
};
